var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 5.5,
    width: 16.5,
    height: 13.75,
    rx: 1.83333,
    stroke: "#231F20",
    strokeOpacity: 0.8,
    strokeWidth: 1.83333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 9.16667C2.75 7.43818 2.75 6.57394 3.28697 6.03697C3.28697 6.03697 3.28697 6.03697 3.28697 6.03697C3.82394 5.5 4.68818 5.5 6.41667 5.5H15.5833C17.3118 5.5 18.1761 5.5 18.713 6.03697C18.713 6.03697 18.713 6.03697 18.713 6.03697C19.25 6.57394 19.25 7.43818 19.25 9.16667H2.75Z",
    fill: "#4F4C4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41797 2.75L6.41797 5.5",
    stroke: "#4F4C4D",
    strokeWidth: 1.83333,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.582 2.75L15.582 5.5",
    stroke: "#4F4C4D",
    strokeWidth: 1.83333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/Calendar-icon.87325e2951dc8d72dbfd9b0736e88feb.svg";
export { ForwardRef as ReactComponent };